<template>
  <transition name="fade" mode="out-in">
    <component :is="currentPage" />
  </transition>
</template>

<script>
import Consent from './Consent.vue'

export default {
  name: 'Manage',
  components: {
    Consent
  },
  computed: {
    currentPage () {
      if (this.localisation === null) {
        return null
      } else if (this.chosenStudy.requiresIdentifier && this.userStudyIdentifier === null) {
        return this.chosenStudy.identifierComponent
      } else {
        return Consent
      }
    }
  },
  created () {
  }
}

</script>
